import { render, staticRenderFns } from "./imageClick.vue?vue&type=template&id=5f2b3751"
import script from "./imageClick.vue?vue&type=script&lang=js"
export * from "./imageClick.vue?vue&type=script&lang=js"
import style0 from "./imageClick.vue?vue&type=style&index=0&id=5f2b3751&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports